import { render, staticRenderFns } from "./Adddialog.vue?vue&type=template&id=480dd6b4"
import script from "./Adddialog.vue?vue&type=script&lang=js"
export * from "./Adddialog.vue?vue&type=script&lang=js"
import style0 from "./Adddialog.vue?vue&type=style&index=0&id=480dd6b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports